// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"216":"764d783c","297":"db501604","643":"8d487acf","657":"d69dd8eb","672":"b491c5aa"}[chunkId] + ".chunk.js";
};